// Module
var code = "<div fg-property-field-common=\"{ fieldname: true, displayname: true, tooltip: false }\"></div> <div fg-property-field-options=\"multiple\"></div> ";
// Exports
export default code;